import {Column} from 'react-table'
import {IndemnityItemsActionsCell} from './IndemnityItemsActionsCell'
import {IndemnityItemsCustomHeader} from './IndemnityItemsCustomHeader'
import {IndemnityItems} from '../../core/_models'
import {IndemnityItemsName} from './IndemnityItemsName'
import {IndemnityItemsMeasurementUnit} from './IndemnityItemsMeasurementUnit'
import {IndemnityItemsDirectDamageValue} from './IndemnityItemsDirectDamageValue'
import {IndemnityItemsOutgoingProfitValue} from './IndemnityItemsOutgoingProfitValue'
import {IndemnityItemsSinglePaymentValue} from './IndemnityItemsSinglePaymentValue'
import {IndemnityItemsReferenceMonth} from './IndemnityItemsReferenceMonth'

const IndemnityItemsColumns: ReadonlyArray<Column<IndemnityItems>> = [
  //HEADER COLUMN - PROJECT
  {
    Header: (props) => (
      <IndemnityItemsCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <IndemnityItemsName IndemnityItems={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <IndemnityItemsCustomHeader
        tableProps={props}
        title='PRODUCTS.UNIT_MEASURE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'measurement_unit',
    Cell: ({...props}) => (
      <IndemnityItemsMeasurementUnit IndemnityItems={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN - ENTREPRENEUR
  {
    Header: (props) => (
      <IndemnityItemsCustomHeader
        tableProps={props}
        title='INDEMNITY_ITEM.DIRECT_DAMAGE_VALUE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'direct_damage_value',
    Cell: ({...props}) => (
      <IndemnityItemsDirectDamageValue IndemnityItems={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN - ENTERPRISES
  {
    Header: (props) => (
      <IndemnityItemsCustomHeader
        tableProps={props}
        title='INDEMNITY_ITEM.OUTGOING_PROFIT_VALUE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'outgoing_profit_value',
    Cell: ({...props}) => (
      <IndemnityItemsOutgoingProfitValue IndemnityItems={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN -  Status ***
  {
    Header: (props) => (
      <IndemnityItemsCustomHeader
        tableProps={props}
        title='INDEMNITY_ITEM.SINGLE_PAYMENT_VALUE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'single_payment_value',
    Cell: ({...props}) => (
      <IndemnityItemsSinglePaymentValue IndemnityItems={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN - ISSUE DATE ***
  {
    Header: (props) => (
      <IndemnityItemsCustomHeader
        tableProps={props}
        title='INDEMNITY_ITEM.REFERECE_MONTH'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'reference_month',
    Cell: ({...props}) => (
      <IndemnityItemsReferenceMonth IndemnityItems={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <IndemnityItemsCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <IndemnityItemsActionsCell IndemnityItems={props.data[props.row.index]} />
    ),
  },
]

export {IndemnityItemsColumns}
